// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchBar_searchContainer__vf6KU","inputContainer":"SearchBar_inputContainer__QfZhv","iconContainer":"SearchBar_iconContainer__M6AI7"};